import { Message } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import articleDeliveryStatuses from "astrid-firestore/src/api/articles/constants/articleDeliveryStatuses";

import Flex from "../../../../components/Flex/Flex";
import OpenButton from "../../../ui/components/OpenButton/OpenButton";

import ArticleDistributeModal from "../ArticleDistributeModal/ArticleDistributeModal";

const needsDeliveryStatuses = [articleDeliveryStatuses.DELIVERY_NEEDED, articleDeliveryStatuses.DELIVERY_FAILED];

export default function ArticlesDeliveryNeededMessage({ publisher, articles, channels }) {
	const { t } = useTranslation();

	const articlesNeedsDelivery = articles.filter((article) =>
		needsDeliveryStatuses.includes(article.delivery?.status),
	);

	if (articlesNeedsDelivery.length === 0) {
		return null;
	}

	return (
		<Message warning>
			<Flex wrap gap={10} alignItems="flex-start">
				<div style={{ maxWidth: "80%" }}>
					<Message.Header>
						{t("articlesNeedDeliveryHeader", "Some articles need to be delivered")}
					</Message.Header>

					<p>
						{t(
							"articlesNeedDeliveryDescription",
							"One or more articles in this work needs to be delivered to their channels. Please deliver them as soon as possible to ensure they are available to your audience.",
						)}
					</p>
				</div>

				<OpenButton color="orange" text={t("deliverAll", "Deliver all")}>
					{({ setOpen }) => (
						<ArticleDistributeModal
							publisher={publisher}
							articles={articlesNeedsDelivery}
							channels={channels}
							onClose={() => setOpen(false)}
						/>
					)}
				</OpenButton>
			</Flex>
		</Message>
	);
}
